export class SessionModel{
  accessToken: string;
}